<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <!-- <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div> -->
          <div class="mb-2">
            <div class="input-icon w-120 position-relative">
              <span class="input-icon-addon">
                <i class="ti ti-calendar text-gray-9"></i>
              </span>
              <a-date-picker
                class="form-control yearpicker"
                v-model:value="value5"
                picker="year"
                :placeholder="String(currentYear)"
              />
            </div>
          </div>
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              :class="{ active: isCollapsed }"
              @click="toggleCollapse"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <welcome-wrap :year="selectedYear" />
      <employee-status :year="selectedYear" />

      <!-- <sales-overview></sales-overview> -->

      <!-- <project-table></project-table> -->

      <schedules-index :year="selectedYear" />
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="#" @click.prevent class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <admin-dashboard-modal></admin-dashboard-modal>
</template>
<script>
import dayjs from "dayjs";
import { useAdminDashboardStore } from "@/stores/adminDashboardStore";

export default {
  data() {
    const currentYear = new Date().getFullYear();
    return {
      title: "Admin Dashboard",
      text: "Dashboard",
      text1: "Admin Dashboard",
      currentYear,
      value5: dayjs().year(currentYear),
      isCollapsed: false,
    };
  },

  computed: {
    selectedYear() {
      const v = this.value5;
      if (!v) return this.currentYear;
      if (typeof v.year === "function") return v.year();
      const n = Number(v);
      return Number.isFinite(n) ? n : this.currentYear;
    },
  },

  watch: {
    selectedYear: {
      immediate: true,
      handler(year) {
        useAdminDashboardStore().loadDashboard(year);
      },
    },
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed) document.body.classList.add("header-collapse");
      else document.body.classList.remove("header-collapse");
    },
  },
};
</script>

